import { Component, Inject, OnInit } from '@angular/core';
import { Settings, SETTINGS_TOKEN } from './settings.config';
import { WindowRef } from './@core/utils';

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(
    private windowRef: WindowRef,
    @Inject(SETTINGS_TOKEN) private settings: Settings
  ) {}

  ngOnInit(): void {

  }
}
